"use client";

import React, { useState, useEffect } from "react";
import ContactStylistCard from "../../src/components/StylistDescriptionCard/ContactStylistCard.js";
import { useDispatch, useSelector } from "react-redux";
import { contactUs } from "../../src/actions/contactusAction.js";
import ChatPopup from "../../src/components/home/ChatPopup.js";
import { seoData } from "../../src/fakeData/seoData.js";
import { Box, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Head from "next/head";
import { usePathname, useSearchParams } from "next/navigation";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function Contact() {
  const dispatch = useDispatch();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [canonicalUrl, setCanonicalUrl] = useState("");

  useEffect(() => {
    const query = searchParams.toString();
    const fullUrl = `https://www.doortodoorbeauty.com${pathname}${query ? `?${query}` : ""}`;
    setCanonicalUrl(fullUrl);
    window.scrollTo(0, 0);
  }, [pathname, searchParams]);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);

  const contactusForm = useSelector((state) => state.contactusForm);
  const language = useSelector((state) => state.language.language);
  const { title, description, keywords, author } = seoData.contact;

  const text = {
    contactTitle: language === "en" ? "Quick Contact" : "त्वरित संपर्क",
    contactDescription:
      language === "en"
        ? "If you have any questions, simply use the following contact details."
        : "यदि आपके कोई प्रश्न हैं, तो कृपया निम्नलिखित संपर्क विवरण का उपयोग करें।",
    successMessage:
      language === "en"
        ? "Your message has been successfully submitted!"
        : "आपका संदेश सफलतापूर्वक भेज दिया गया है!",
    placeholderName: language === "en" ? "Your Name " : "आपका नाम",
    placeholderEmail: language === "en" ? "Your Email " : "आपकी ईमेल",
    placeholderSubject: language === "en" ? "Subject " : "विषय",
    placeholderMessage: language === "en" ? "Message " : "संदेश",
    successButtonLabel: language === "en" ? "Send Message " : "संदेश भेजें",
    cardEmail: language === "en" ? "Email Us " : "हमें ईमेल करें",
    cardCall: language === "en" ? "Call Us " : "हमें कॉल करें",
    cardLocation: language === "en" ? "Location " : "स्थान",
    cardLocationDescription:
      language === "en"
        ? "G- 276 Sector 22 Near by Federal Bank Noida Utter Pradesh, Pin code 201301 "
        : "ब्लॉक ए4, सेक्टर 16, नोएडा, उत्तर प्रदेश 201301",
  };

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(contactUs(name, email, subject, message));
    setTimeout(() => setIsSubmitted(true), 2000);
    setName("");
    setEmail("");
    setSubject("");
    setMessage("");
  };

  useEffect(() => {
    const handleScroll = () => setShowScrollButton(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      </Head>

      <div className="bg-gray-50">
        <div
          className="flex justify-center py-10 lg:py-20 bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom"
          style={{ backgroundImage: `url('/assets/Blog/BlogHeader.jpg')` }}
        >
          <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
            <div className="w-full flex justify-center flex-col relative">
              <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-serif text-center text-pink-600" style={{color: '#DB2777'}}>Contact Us</h1>
            </div>
          </div>
        </div>
        <div className="bg-white">
        <div className="block mx-auto max-w-screen-2xl ">
        <ChatPopup />
        {/* <SliderBannerShowData /> */}
        
        </div>
          <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">



          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-8">
    <div className="border p-10 rounded-lg text-center">
      <span className="flex justify-center text-4xl text-pink-600 mb-4 ">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          height="1em"
          width="1em"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      </span>
      <h2 style={{
                fontSize: '1.4rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
              }}  className="text-xl lg:text-2xl mb-2 font-semibold">{text.cardEmail}</h2>
      <p style={{
                fontSize: '1rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.5',
                textAlign: 'center', /* Center the text inside the block */
                margin: '0 0 10px',
              }}
              className="text-base leading-6 text-justify justify-center"
              >
        <a href="mailto:support@doortodoorbeauty.com" className="text-pink-600" style={{color: '#DB2777'}}>
          support@doortodoorbeauty.com
        </a>
      </p>
    </div>
    <div className="border p-10 rounded-lg text-center">
      <span className="flex justify-center text-4xl text-pink-600 mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          height="1em"
          width="1em"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      </span>
      <h2 style={{
                fontSize: '1.4rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
              }}  className="text-xl lg:text-2xl mb-2 font-semibold">{text.cardCall}</h2>
      <p style={{
                fontSize: '1rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.5',
                textAlign: 'center', /* Center the text inside the block */
                margin: '0 0 10px',
              }}
              className="text-base leading-6 text-justify justify-center"
              >
        <a href="tel:+91-7289859266" className="text-pink-600" style={{color: '#DB2777'}}>
          +91-72898 59266
        </a>
      </p>
    </div>
    <div className="border p-10 rounded-lg text-center">
      <span className="flex justify-center text-4xl text-pink-600 mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          height="1em"
          width="1em"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      </span>
      <h2 style={{
                fontSize: '1.4rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
              }}  className="text-xl lg:text-2xl mb-2 font-semibold">{text.cardLocation}</h2>
      <p style={{
                fontSize: '1rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.5',
                textAlign: 'center', /* Center the text inside the block */
                margin: '0 0 10px',
              }}
              className="text-base leading-6 text-justify justify-center"
              >
        {text.cardLocationDescription}
      </p>
    </div>
  </div>











  <div className="px-0 pt-24 mx-auto items-center flex flex-col md:flex-row w-full justify-between">
    <div className="hidden md:w-full lg:w-5/12 lg:flex flex-col h-full">
      <span
        style={{
          boxSizing: "border-box",
          display: "inline-block",
          overflow: "hidden",
          width: "initial",
          height: "initial",
          background: "none",
          opacity: "1",
          border: "0px",
          margin: "0px",
          padding: "0px",
          position: "relative",
          maxWidth: "100%",
        }}
      >
        <span
          style={{
            boxSizing: "border-box",
            display: "block",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: "1",
            border: "0px",
            margin: "0px",
            padding: "0px",
            maxWidth: "100%",
          }}
        >
          <img
            aria-hidden="true"
            style={{
              display: "block",
              maxWidth: "100%",
              width: "initial",
              height: "initial",
              background: "none",
              opacity: "1",
              border: "0px",
              margin: "0px",
              padding: "0px",
            }}
            alt='contact us'
            src="/assets/img/contact-us.png"
          ></img>
        </span>
      </span>
    </div>
    
    <Container
  maxWidth="md" // Adjust maxWidth to md for a smaller container size
  sx={{ py: { xs: 8, lg: 15 }, px: { xs: 2, sm: 6 } }} // Reduced padding
  style={{ marginTop: '-100px' }}
  className="px-0 pb-2 flex flex-col w-full lg:w-5/12"
>
  {/* Material-UI Box to apply `sx` styles */}
  <Item sx={{ boxShadow: 7, borderRadius: '16px', borderRight: 8, padding: { xs: 3, sm: 4 } }}>
    <form className="w-full mx-auto flex flex-col justify-center" onSubmit={submitHandler}>
      <div className="mb-8"> {/* Reduced margin bottom */}
        <h3 className="text-3xl sm:text-4xl md:text-4xl lg:text-3xl font-semibold mb-3">
          {text.contactTitle}
        </h3>
        <p className="text-base sm:text-lg md:text-xl lg:text-base opacity-90 leading-6">
          {text.contactDescription}
        </p>
        {isSubmitted && (
          <p className="text-green-600 mt-4 text-base sm:text-lg md:text-xl lg:text-base">
            
          </p>
        )}
      </div>

      <div className="flex flex-col space-y-4"> {/* Reduced space between inputs */}
        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0">
          <div className="w-full md:w-1/2">
            <label className="block text-gray-500 font-medium text-base sm:text-lg md:text-xl lg:text-base leading-none mb-2">
            {text.placeholderName}

            </label>
            <div className="relative">
              <input
                name="name"
                type="text"
                placeholder=" "
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="py-2 px-4 md:px-5 w-full appearance-none border text-base sm:text-lg opacity-75 text-input rounded-md placeholder-body min-h-11 transition duration-200 focus:ring-0 ease-in-out bg-white border-gray-200 focus:outline-none focus:border-emerald-500"
              />
            </div>
          </div>

          <div className="w-full md:w-1/2 md:ml-2.5 lg:ml-5 mt-2 md:mt-0">
            <label className="block text-gray-500 font-medium text-base sm:text-lg md:text-xl lg:text-base leading-none mb-2">
            {text.placeholderEmail}
            </label>
            <div className="relative">
              <input
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="py-2 px-4 md:px-5 w-full appearance-none border text-base sm:text-lg opacity-75 text-input rounded-md placeholder-body min-h-11 transition duration-200 focus:ring-0 ease-in-out bg-white border-gray-200 focus:outline-none focus:border-emerald-500"
              />
            </div>
          </div>
        </div>

        <div className="relative">
          <label className="block text-gray-500 font-medium text-base sm:text-lg md:text-xl lg:text-base leading-none mb-2">
            {text.placeholderSubject}
          </label>
          <div className="relative">
            <input
              name="subject"
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="py-2 px-4 md:px-5 w-full appearance-none border text-base sm:text-lg opacity-75 text-input rounded-md placeholder-body min-h-11 transition duration-200 focus:ring-0 ease-in-out bg-white border-gray-200 focus:outline-none focus:border-emerald-500"
            />
          </div>
        </div>

        <div className="relative mb-4">
          <label className="block text-gray-500 font-medium text-base sm:text-lg md:text-xl lg:text-base leading-none mb-2">
            {text.placeholderMessage}
          </label>
          <textarea
            name="message"
            className="px-4 py-3 w-full rounded appearance-none opacity-75 transition duration-300 ease-in-out text-base sm:text-lg focus:ring-0 bg-white border border-gray-300 focus:shadow-none focus:outline-none focus:border-gray-500"
            autoComplete="off"
            spellCheck="false"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows="4"
          ></textarea>
        </div>

        {/* Centering the button */}
        <div className="relative flex justify-center">
          <button
            type="submit"
            className="md:text-xl leading-6 inline-flex items-center cursor-pointer transition ease-in-out duration-300 font-semibold text-center justify-center border-0 border-transparent rounded-md bg-pink-600 text-white px-6 py-4 hover:bg-emerald-600"
          >
            {text.successButtonLabel}
          </button>
        </div>
      </div>
    </form>
  </Item>
</Container>



  </div>




          </div>
          <ContactStylistCard /> <br /><br />
        </div>
      </div>

      {showScrollButton && (
        <button
          className="fixed bottom-[100px] right-8 bg-pink-600 hover:bg-emerald-600 text-white p-3 rounded-full shadow-lg"
          onClick={scrollToTop}
        >
          ⬆️
        </button>
      )}
    </>
  );
}
